import Model from "./Model";

export default class ExamModeModel extends Model {
  id: number
  name: string
  description: string

  constructor(examMode: any, getters:any) {
    super(getters);
    this.id = examMode.id;
    this.name = examMode.name;
    this.description = examMode.description;
  }

  raw() {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
    }
  }
}